import React from "react";
import { couple, heroImages } from "../mock";

export default function Hero() {
  return (
    <section id="top" className="relative h-screen min-h-[640px] w-full overflow-hidden">
      {/* Split images */}
      <div className="absolute inset-0 grid grid-cols-1 md:grid-cols-2">
        <div className="relative overflow-hidden">
          <img
            src={heroImages.left}
            alt="The couple"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="relative overflow-hidden hidden md:block">
          <img
            src={heroImages.right}
            alt="The couple walking"
            className="h-full w-full object-cover"
          />
        </div>
      </div>

      {/* Warm darkening overlay for text legibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#211E1A]/45 via-[#211E1A]/25 to-[#211E1A]/55" />

      {/* Center content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <p className="reveal is-visible text-[#F4EFE6] text-[12px] md:text-[13px] uppercase tracking-widest-2 mb-5">
          {couple.tagline}
        </p>
        <h1 className="reveal is-visible font-serif-display text-[#F4EFE6] font-medium leading-[0.95] text-[58px] sm:text-[84px] md:text-[110px] lg:text-[128px]">
          {couple.names}
        </h1>
        <div className="reveal is-visible mt-6 flex items-center gap-3 text-[#F4EFE6] text-sm md:text-base tracking-wide">
          <span>{couple.dateLabel}</span>
          <span className="w-1 h-1 rounded-full bg-[#F4EFE6]" />
          <span>{couple.locationShort}</span>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-[1px] h-12 bg-[#F4EFE6]/70 mx-auto animate-pulse" />
      </div>
    </section>
  );
}
